export enum Role {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  USER = 'USER',
  GUEST = 'GUEST',
}

import type { AdminUsersQuery } from '@/gql/graphql';

/** A user row as the admin console lists it — the generated query result. */
export type User = AdminUsersQuery['adminUsers']['items'][number];

export enum AccountType {
  internal = 'internal',
  customer = 'customer',
}

export enum InternalUserStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface UserContext {
  uid: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: Role;
  /** Both of these gate the dashboard shell — see `dashboard/layout.tsx`. */
  accountType: AccountType;
  internalStatus: InternalUserStatus;
  permissions: string[];
  isAuthenticated: boolean;
}

